import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { switchActiveMode } from "../../redux/actions";
import { COLORS } from "../../assets/colors";

const ModeSwitcher = ({ inDropdown = false }) => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.auth);

  if (currentUser?.user_type !== "both") {
    return null;
  }

  const isDriver = currentUser?.active_mode === "driver";

  const handleToggle = (e) => {
    e.stopPropagation(); // Prevents dropdown from closing when toggling mode
    const newMode = isDriver ? "passenger" : "driver";
    dispatch(switchActiveMode(newMode));
  };

  return (
    <SwitcherContainer $inDropdown={inDropdown} onClick={handleToggle}>
      <ToggleSwitch $isDriver={isDriver} $inDropdown={inDropdown}>
        <div className="option passenger">
          <span>🧳 Passenger</span>
        </div>
        <div className="option driver">
          <span>🚗 Driver</span>
        </div>
        <div className="slider"></div>
      </ToggleSwitch>
    </SwitcherContainer>
  );
};

export default ModeSwitcher;

const SwitcherContainer = styled.div`
  display: flex;
  align-items: center;
  margin: ${(props) => (props.$inDropdown ? "0" : "0 1rem")};
  cursor: pointer;
  
  @media (max-width: 880px) {
    margin: 1rem auto;
    justify-content: center;
  }
`;

const ToggleSwitch = styled.div`
  position: relative;
  display: flex;
  background: ${(props) => (props.$inDropdown ? "#f1f5f9" : "rgba(255, 255, 255, 0.2)")};
  border-radius: 30px;
  width: 210px;
  height: 36px;
  overflow: hidden;
  border: 1px solid ${(props) => (props.$inDropdown ? "#e2e8f0" : "rgba(255, 255, 255, 0.3)")};

  .option {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    transition: color 0.3s ease;
    font-size: 0.85rem;
    font-weight: 600;
    
    span {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  .passenger {
    color: ${(props) =>
      props.$inDropdown
        ? !props.$isDriver
          ? "white"
          : "rgba(30, 41, 59, 0.7)"
        : !props.$isDriver
        ? COLORS.primaryColor
        : "white"};
  }

  .driver {
    color: ${(props) =>
      props.$inDropdown
        ? props.$isDriver
          ? "white"
          : "rgba(30, 41, 59, 0.7)"
        : props.$isDriver
        ? COLORS.primaryColor
        : "white"};
  }

  .slider {
    position: absolute;
    top: 2px;
    left: 2px;
    height: 30px;
    width: 103px;
    background: ${(props) => (props.$inDropdown ? COLORS.primaryColor : "white")};
    border-radius: 28px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(${(props) => (props.$isDriver ? "103px" : "0")});
    z-index: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;
